import { inject, Injectable } from "@angular/core";

import { map, Observable, tap } from "rxjs";

import { ActivatePlanResponse, RequestState, SettingsResponse } from "@shared/models";
import { GlobalService, PlanApiService, SettingsApiService } from "@shared/services";
import { CacheId } from "@shared/enums";
import { MessageService } from "primeng/api";
import { Router } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class OptionsService {
  settingsApiService = inject(SettingsApiService);
  planApiService = inject(PlanApiService);
  globalService = inject(GlobalService);
  messageService = inject(MessageService);
  router = inject(Router);

  settings: SettingsResponse = {} as SettingsResponse;

  getSettings(): Observable<RequestState<SettingsResponse>> {
    return this.settingsApiService.getSettings().pipe(
      tap((response) => {
        if (response.response) {
          this.settings = response.response;
        }
      })
    );
  }

  saveSettings(vmaxValue: string, projValue: string): Observable<RequestState<SettingsResponse>> {
    return this.settingsApiService.updateSettings(this.settings, vmaxValue, projValue);
  }

  activateStandbyPlan(): Observable<ActivatePlanResponse> {
    this.globalService.saving.set(true);
    return this.planApiService.activateStandbyPlan().pipe(
      map((response) => {
        if (response) {
          const activePlan = localStorage.getItem(CacheId.ActivePlan);
          const standbyPlan = localStorage.getItem(CacheId.StandbyPlan);
          if (activePlan && standbyPlan) {
            const activePlanObj = JSON.parse(activePlan);
            const standbyPlanObj = JSON.parse(standbyPlan);
            activePlanObj.plans = response.activePlan;
            standbyPlanObj.plans = response.standbyPlan;
            localStorage.setItem(CacheId.ActivePlan, JSON.stringify(activePlanObj));
            localStorage.setItem(CacheId.StandbyPlan, JSON.stringify(standbyPlanObj));
          }
          this.router.navigate(["/standby"]);
          this.globalService.saving.set(false);
          this.messageService.clear();
          this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: "Standby plan activated successfully",
            key: "noReply",
          });
          return response;
        } else {
          this.globalService.saving.set(false);
          return {} as ActivatePlanResponse;
        }
      })
    );
  }
}
